import { AutogenLayoutTimecardHistoryReport } from "./autogen/AutogenLayoutTimecardHistoryReport";

export class TimecardHistoryReport extends AutogenLayoutTimecardHistoryReport {
    override onLoad(): void {
        this.textboxSort.selectedItem = this.textboxSort.items[0];
    }
}